import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    TemplateRef,
    inject,
    input,
    output,
} from '@angular/core';
import { Leave } from 'src/app/classes/leave';
import { User } from 'src/app/classes/user.class';
import type { ProjectDay, ProjectDayUserState } from '../employee-planning.component';

type BlockedUser = {
    icon: string;
    description: string;
    startDate: Date;
    endDate: Date;
};

export type EmployeePlanningProjectClick = {
    event: MouseEvent;
    day: ProjectDay['days'][number];
    projectDayUser?: ProjectDayUserState;
    performerId?: number;
    rowKey: string;
};

@Component({
    selector: 'tr[app-employee-planning-user-row]',
    templateUrl: './employee-planning-user-row.component.html',
    styleUrls: ['./employee-planning-user-row.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
// The planning table can contain tens of thousands of cells. Keeping each employee in an OnPush
// component prevents an unrelated click elsewhere on the page from reevaluating every employee cell.
export class EmployeePlanningUserRowComponent {
    readonly blockedMap = input.required<Map<string, BlockedUser> | null>();
    readonly contextMenu = input.required<TemplateRef<unknown>>();
    readonly dayUserMap = input.required<Map<string, string>>();
    readonly leaveDayUserMap = input.required<Map<string, Leave>>();
    readonly leaveDays = input.required<ProjectDay['days']>();
    readonly projectDays = input.required<ProjectDay[]>();
    readonly projectDayUserMap = input.required<Map<string, ProjectDayUserState>>();
    readonly user = input.required<User>();
    readonly userDayConflictMap = input.required<Map<string, boolean>>();
    readonly userDayHasNightMap = input.required<Map<string, boolean>>();
    readonly weekCount = input<number>();
    readonly print = input<boolean>();

    readonly contextMenuOpened = output<Date>();
    readonly leaveClicked = output<Date>();
    readonly projectClicked = output<EmployeePlanningProjectClick>();

    private readonly changeDetectorRef = inject(ChangeDetectorRef);

    markForCheck(): void {
        this.changeDetectorRef.markForCheck();
    }
}
